export const sampleWeeklyReviews = [
  {
    weekNumber: 1,
    score: 31,
    stats: { total: 13, done: 4, planned: 7, cancelled: 2 },
    trend: [38, 18, 8, 8, 8, 8, 18],
    bestDay: "Monday",
    weakDay: "Wednesday",
    objectives: {
      Productivity: 1,
      Focus: 2,
      Learning: 4,
      Discipline: 5,
      Career: 1
    },
    roach: { avgScore: 1, type: "Lost Survivor" },
    signals: {
      focus: 46,
      consistency: 67,
      discipline: 31,
      resilience: 12
    },
    weaknesses: [
      "Execution inconsistency",
      "Behavior stability dropping"
    ],
    insights: [
      "Execution consistency needs improvement.",
      "Awareness phase has started.",
      "Recovery behaviors emerging."
    ]
  },

  {
    weekNumber: 2,
    score: 39,
    stats: { total: 12, done: 5, planned: 6, cancelled: 1 },
    trend: [28, 41, 39, 32, 18, 22, 35],
    bestDay: "Tuesday",
    weakDay: "Friday",
    objectives: {
      Productivity: 2,
      Focus: 2,
      Learning: 3,
      Discipline: 4,
      Career: 1
    },
    roach: { avgScore: 2, type: "Lost Survivor" },
    signals: {
      focus: 51,
      consistency: 70,
      discipline: 37,
      resilience: 18
    },
    weaknesses: [
      "Phone distraction",
      "Low resilience"
    ],
    insights: [
      "Focus recovering gradually.",
      "Planning quality improved.",
      "Behavior still fragile."
    ]
  },

  {
    weekNumber: 3,
    score: 46,
    stats: { total: 12, done: 7, planned: 4, cancelled: 1 },
    trend: [42, 45, 48, 38, 40, 52, 57],
    bestDay: "Thursday",
    weakDay: "Sunday",
    objectives: {
      Productivity: 2,
      Focus: 2,
      Learning: 4,
      Discipline: 3,
      Career: 1
    },
    roach: { avgScore: 3, type: "Recovering Survivor" },
    signals: {
      focus: 58,
      consistency: 73,
      discipline: 45,
      resilience: 29
    },
    weaknesses: [
      "Late-night distraction",
      "Weak recovery routine"
    ],
    insights: [
      "Recovery momentum established.",
      "Task completion improving.",
      "Self-awareness increasing."
    ]
  },

  {
    weekNumber: 4,
    score: 53,
    stats: { total: 12, done: 8, planned: 3, cancelled: 1 },
    trend: [48, 52, 50, 61, 56, 58, 54],
    bestDay: "Thursday",
    weakDay: "Sunday",
    objectives: {
      Productivity: 3,
      Focus: 2,
      Learning: 3,
      Discipline: 3,
      Career: 1
    },
    roach: { avgScore: 4, type: "Recovering Survivor" },
    signals: {
      focus: 62,
      consistency: 76,
      discipline: 49,
      resilience: 34
    },
    weaknesses: [
      "Weekend inconsistency"
    ],
    insights: [
      "Discipline becoming visible.",
      "Focus interruptions reduced.",
      "Behavior becoming more predictable."
    ]
  },

  {
    weekNumber: 5,
    score: 61,
    stats: { total: 12, done: 9, planned: 2, cancelled: 1 },
    trend: [58, 63, 60, 67, 62, 65, 64],
    bestDay: "Monday",
    weakDay: "Saturday",
    objectives: {
      Productivity: 3,
      Focus: 2,
      Learning: 3,
      Discipline: 3,
      Career: 1
    },
    roach: { avgScore: 5, type: "Adaptive Survivor" },
    signals: {
      focus: 66,
      consistency: 79,
      discipline: 57,
      resilience: 43
    },
    weaknesses: [
      "Energy management"
    ],
    insights: [
      "Execution becoming reliable.",
      "Recovery speed increasing.",
      "Planning quality improving."
    ]
  },

  {
    weekNumber: 6,
    score: 67,
    stats: { total: 12, done: 9, planned: 3, cancelled: 0 },
    trend: [64, 68, 66, 71, 69, 65, 70],
    bestDay: "Tuesday",
    weakDay: "Sunday",
    objectives: {
      Productivity: 3,
      Focus: 2,
      Learning: 2,
      Discipline: 3,
      Career: 2
    },
    roach: { avgScore: 6, type: "Adaptive Survivor" },
    signals: {
      focus: 70,
      consistency: 82,
      discipline: 61,
      resilience: 52
    },
    weaknesses: [
      "Occasional procrastination"
    ],
    insights: [
      "Habits now support execution.",
      "Momentum building steadily.",
      "Confidence increasing."
    ]
  },

  {
    weekNumber: 7,
    score: 72,
    stats: { total: 12, done: 10, planned: 2, cancelled: 0 },
    trend: [70, 71, 75, 74, 72, 73, 76],
    bestDay: "Wednesday",
    weakDay: "Saturday",
    objectives: {
      Productivity: 3,
      Focus: 2,
      Learning: 2,
      Discipline: 3,
      Career: 2
    },
    roach: { avgScore: 7, type: "Momentum Builder" },
    signals: {
      focus: 73,
      consistency: 84,
      discipline: 68,
      resilience: 58
    },
    weaknesses: [
      "Overcommitment risk"
    ],
    insights: [
      "Execution becoming identity-driven.",
      "Focus sessions lasting longer.",
      "Discipline stabilizing."
    ]
  },

  {
    weekNumber: 8,
    score: 78,
    stats: { total: 12, done: 10, planned: 2, cancelled: 0 },
    trend: [75, 78, 80, 76, 79, 81, 77],
    bestDay: "Thursday",
    weakDay: "Sunday",
    objectives: {
      Productivity: 2,
      Focus: 3,
      Learning: 2,
      Discipline: 3,
      Career: 2
    },
    roach: { avgScore: 8, type: "Momentum Builder" },
    signals: {
      focus: 77,
      consistency: 87,
      discipline: 72,
      resilience: 64
    },
    weaknesses: [
      "Recovery optimization needed"
    ],
    insights: [
      "Focus quality significantly improved.",
      "Task completion highly consistent.",
      "Behavioral drift minimal."
    ]
  },

  {
    weekNumber: 9,
    score: 82,
    stats: { total: 12, done: 11, planned: 1, cancelled: 0 },
    trend: [80, 82, 84, 81, 85, 83, 79],
    bestDay: "Monday",
    weakDay: "Saturday",
    objectives: {
      Productivity: 2,
      Focus: 3,
      Learning: 2,
      Discipline: 2,
      Career: 3
    },
    roach: { avgScore: 9, type: "Resilient Survivor" },
    signals: {
      focus: 80,
      consistency: 89,
      discipline: 78,
      resilience: 71
    },
    weaknesses: [
      "Work-life balance"
    ],
    insights: [
      "Resilience emerging strongly.",
      "Setbacks no longer derail execution.",
      "Identity shift becoming visible."
    ]
  },

  {
    weekNumber: 10,
    score: 86,
    stats: { total: 12, done: 11, planned: 1, cancelled: 0 },
    trend: [84, 86, 88, 85, 89, 87, 86],
    bestDay: "Tuesday",
    weakDay: "Sunday",
    objectives: {
      Productivity: 2,
      Focus: 2,
      Learning: 2,
      Discipline: 2,
      Career: 4
    },
    roach: { avgScore: 9, type: "Resilient Survivor" },
    signals: {
      focus: 83,
      consistency: 90,
      discipline: 84,
      resilience: 76
    },
    weaknesses: [
      "Minor energy fluctuations"
    ],
    insights: [
      "Career clarity increasing.",
      "Execution highly dependable.",
      "Focus becoming automatic."
    ]
  },

  {
    weekNumber: 11,
    score: 89,
    stats: { total: 12, done: 12, planned: 0, cancelled: 0 },
    trend: [88, 89, 91, 87, 90, 92, 88],
    bestDay: "Wednesday",
    weakDay: "-",
    objectives: {
      Productivity: 2,
      Focus: 2,
      Learning: 2,
      Discipline: 2,
      Career: 4
    },
    roach: { avgScore: 9, type: "Focused Builder" },
    signals: {
      focus: 85,
      consistency: 91,
      discipline: 87,
      resilience: 79
    },
    weaknesses: [],
    insights: [
      "Behavior now self-sustaining.",
      "Consistency is a strength.",
      "Identity aligned with goals."
    ]
  },

  {
    weekNumber: 12,
    score: 91,
    stats: { total: 12, done: 12, planned: 0, cancelled: 0 },
    trend: [90, 92, 91, 93, 90, 94, 91],
    bestDay: "Thursday",
    weakDay: "-",
    objectives: {
      Productivity: 1,
      Focus: 2,
      Learning: 2,
      Discipline: 2,
      Career: 5
    },
    roach: { avgScore: 9, type: "Focused Builder" },
    signals: {
      focus: 86,
      consistency: 92,
      discipline: 89,
      resilience: 81
    },
    weaknesses: [],
    insights: [
      "Transformation stabilized.",
      "Execution driven by identity, not motivation.",
      "Ready for the next evolution cycle."
    ]
  }
];